import React from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import NavPills from "./Component/NavPills";
import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import IconButton from "@material-ui/core/IconButton";
import Utils from "../../utility";
import { activeUserService } from "../../services/index";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "auto",
    paddingLeft: 17,
    paddingRight: 0,
    "@media (min-width: 768px) and (max-width: 1024px)": {
      paddingLeft: 0,
    },
  },

  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: "100vh",
    overflowX: "hidden",
    backgroundColor: "#F6F6F6",
  },

  container: {
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(0),
    marginLeft: theme.spacing(10),
    paddingRight: theme.spacing(17),
    "@media (min-width: 768px) and (max-width: 1024px)": {
      marginLeft: "0px",
      paddingTop: "64px",
      paddingRight: "25px",
      paddingBottom: "0",
    },
  },
  link: {
    marginTop: theme.spacing(-6),
    marginBottom: theme.spacing(1),
    color: "#001441",
    fontWeight: "bold",
    "@media (min-width: 768px) and (max-width: 1024px)": {
      display: "none",
    },
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
    padding: '2px 0px 7px 1px',
    "@media (min-width: 768px) and (max-width: 1024px)": {
      width: "88px",
    },
  },
  iconButton: {
    maxWidth: 30,
    maxHeight: 25,
  },
  search: {
    "@media (min-width: 1025px)": {
      display: "none",
    },
  },

  "@media (min-width: 768px) and (max-width: 1024px)": {
    search: {
      display: "block",
      width: "132px",
      height: "40px",
      padding: "2px 5px 0 0",
      alignItems: "center",
    },
    iconButton: {
      maxWidth: 30,
      maxHeight: 25,
      marginTop: '7px',
    },
  },

  grid: {
    display: "flex",
    justifyContent: "space-between",
    paddingBottom: "36px",
    marginTop: "-6px",
    "@media (min-width:768px) and (max-width:1024px)": {
      // display: "flex",
      //   justifyContent: "end",
    },
  },
  heading: {
    color: "#001441",
    fontWeight: "bold",
    "@media (min-width: 1025px)": {
      display: "none",
    },
  },
}));

export default function User(props) {
  const classes = useStyles();
  const [isLoading, setLoading] = React.useState(true);
  const [activeUser, setactiveUser] = React.useState([]);
  const [keyword, setKeyword] = React.useState("");

  React.useEffect(() => {
    getactiveUser();
  }, []);

  const getactiveUser = async () => {
    let [error, nftUsers] = await Utils.parseResponse(
      activeUserService.getactiveUser()
    );
    if (error || !nftUsers) return;
    setactiveUser(nftUsers);
    setLoading(false)
  };

  const handleSearchIcon = () => {
    if (activeUser.length > 0) {
      let searchkeyword = keyword;
      let data = {
        key: searchkeyword, 
      };
      onChangeSearch(data);
    }
  };

  const onChangeSearch = async (data) => {
    const [error, res] = await Utils.parseResponse(
      activeUserService.searchUsers(data)
    );

    if (error || !res) return;
    setactiveUser(res);
  };

  return (
    <div className={classes.root}>
      <CssBaseline />
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="" className={classes.container}>
          <Typography className={classes.link} variant="h6">
            Users
          </Typography>
          <Grid className={classes.grid}>
            <Typography className={classes.heading} variant="h6">
              Users
            </Typography>
            <Paper component="form" elevation={0} className={classes.search}>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <div>
                  <InputBase
                    className={classes.input}
                    placeholder="search"
                    inputProps={{ "aria-label": "search " }}
                    onChange={(e) => {setKeyword(e.target.value); handleSearchIcon()}}
                  />
                </div>
                <div>
                  <IconButton
                    // type="submit"
                    className={classes.iconButton}
                    aria-label="search"
                    onClick={handleSearchIcon}
                  >
                    <img src="/images/searchicon.png" />
                  </IconButton>
                </div>
              </div>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            <NavPills user={props?.user} isLoading={isLoading} tabActiveUser={activeUser}/>
          </Grid>
        </Container>
      </main>
    </div>
  );
}
